import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Users } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Base offset to reflect early supporters from Google Form + offline signups
const BASE_COUNT = 47;

const WaitlistCounter = ({ variant = 'large', refreshKey = 0 }) => {
  const [count, setCount] = useState(BASE_COUNT);
  const [displayCount, setDisplayCount] = useState(BASE_COUNT);

  const fetchCount = async () => {
    try {
      const response = await axios.get(`${API}/waitlist/count`);
      const dbCount = response.data.count || 0;
      setCount(BASE_COUNT + dbCount);
    } catch (error) {
      console.error('Error fetching waitlist count:', error);
    }
  };

  useEffect(() => {
    fetchCount();
    const interval = setInterval(fetchCount, 30000);
    return () => clearInterval(interval);
  }, [refreshKey]);

  // Animate counter
  useEffect(() => {
    if (displayCount === count) return;
    const diff = count - displayCount;
    const step = Math.ceil(Math.abs(diff) / 20) * Math.sign(diff);
    const timer = setTimeout(() => {
      const next = displayCount + step;
      if ((step > 0 && next >= count) || (step < 0 && next <= count)) {
        setDisplayCount(count);
      } else {
        setDisplayCount(next);
      }
    }, 30);
    return () => clearTimeout(timer);
  }, [count, displayCount]);

  if (variant === 'badge') {
    return (
      <div 
        data-testid="waitlist-counter-badge"
        className="inline-flex items-center space-x-2 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full shadow-sm border border-orange-200"
      >
        <div className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-orange-400 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 bg-orange-500"></span>
        </div>
        <span className="text-sm font-semibold text-gray-700">
          <span className="text-blue-900 font-bold">{displayCount}+</span> Founding Families have joined
        </span>
      </div>
    );
  }

  return (
    <div 
      data-testid="waitlist-counter"
      className="inline-flex items-center justify-center bg-gradient-to-r from-orange-500/20 to-orange-400/20 backdrop-blur-sm border-2 border-orange-400/40 rounded-2xl px-8 py-4 shadow-xl"
    >
      <Users className="w-6 h-6 text-orange-300 mr-3" />
      <div className="text-left">
        <div className="flex items-baseline space-x-2">
          <span className="text-4xl font-bold text-white tabular-nums">{displayCount}+</span>
          <div className="relative flex h-3 w-3">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-orange-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-3 w-3 bg-orange-400"></span>
          </div>
        </div>
        <p className="text-sm text-orange-100 font-medium">Founding Families joined</p>
      </div>
    </div>
  );
};

export default WaitlistCounter;
